import { motion, AnimatePresence } from "framer-motion";
import styled from "styled-components";
import { useState, useMemo } from "react";
import DraggableEmployee from "./DraggableEmployee";
import CustomSearchInput from "../common/Inputs/CustomSearchInput";
import { Flex, ScrollAreaAutosize } from "@mantine/core";

const slideVariants = {
  hidden: {
    width: 0,
    opacity: 0,
    transition: {
      duration: 0.4,
      ease: "easeInOut",
    },
  },
  visible: {
    width: "25%",
    opacity: 1,
    transition: {
      duration: 0.4,
      ease: "easeInOut",
    },
  },
  exit: {
    width: 0,
    opacity: 0,
    transition: {
      duration: 0.4,
      ease: "easeInOut",
    },
  },
};

interface SlidingPanelProps {
  isVisible: boolean;
  employees: any[];
}

const SideBarForEmployee = ({ isVisible, employees }: SlidingPanelProps) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredEmployees = useMemo(() => {
    return employees?.filter((emp) =>
      emp?.name?.toLowerCase().startsWith(searchTerm.toLowerCase())
    );
  }, [searchTerm, employees]);

  return (
    <AnimatePresence mode="wait">
      {isVisible && (
        <MotionDiv
          key="sliding-panel"
          variants={slideVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <Wrapper>
            <CustomSearchInput
              placeholder="Çalışan Ara"
              value={searchTerm}
              onChange={(e: any) => setSearchTerm(e.target.value)}
            />
            <ScrollAreaAutosize offsetScrollbars>
              <Flex style={{}} direction={"column"} gap={12}>
                {filteredEmployees?.map((employee) => (
                  <DraggableEmployee
                    key={employee?.id}
                    id={employee?.id}
                    name={employee?.name}
                    contract={employee?.contract}
                  />
                ))}
              </Flex>
            </ScrollAreaAutosize>
          </Wrapper>
        </MotionDiv>
      )}
    </AnimatePresence>
  );
};

export default SideBarForEmployee;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 24px;
  height: 800px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
`;

const MotionDiv = styled(motion.div)`
  height: 800px;
  overflow: hidden;
  position: relative;
`;
